export { StoreDevtoolsModule } from './src/instrument';
export { StoreDevtools } from './src/devtools';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngrx/store-devtools/index.js
// module id = 181
// module chunks = 4